export const STORE_PRODUCTS = [
  {
    id: "architect-ai",
    name: "Architect AI",
    category: "Students",
    tagColor: "#2878C0",
    price: "Free",
    image: "/assets/store/2.png",
    shortDesc: "GenAI Resume Builder & ATS Analyzer.",
    desc: "Architect AI is a full-stack, real-time resume generation and analysis tool. It combines a blazing-fast live preview interface with the analytical power of Google's Gemini API to act as a strict, constructive Applicant Tracking System (ATS). Built with an emphasis on rapid prototyping and clean architecture, this application allows users to dynamically craft their professional profiles, score them against target roles, and manage their sessions securely.",
    features: [],
  },
  {
    id: "lims",
    name: "Life Insurance Management System",
    category: "Students",
    tagColor: "#1A9A60",
    price: "Free",
    image: "/assets/store/lims.png",
    shortDesc: "An enterprise-style web dashboard for life insurance firms built using PHP and MySQL. It features secure role-based access control (RBAC), allowing Agents and Master Agents to manage client records, policies, nominee details, and payment histories with full database audit capabilities.",
    desc: "The Life Insurance Management System (LIMS) is a web-based administrative dashboard designed to streamline operations for life insurance providers. Built using native PHP, MySQL, HTML5, and CSS, the system implements secure session management, multi-level access privileges, and image uploads for document and profile management.",
    features: ["Agents can create clients", "Agents can only edit and delete info of the client they created", "Master Agent can create, update, delete all clients and agents info", "Payment records and nominees can be added and managed by agents"],
  },
  {
    id: "todo",
    name: "TODO",
    category: "Students",
    tagColor: "#1A9A60",
    price: "Free",
    image: "/assets/store/todo.png",
    shortDesc: "A gamified task management web application designed for parents and children. Parents can assign daily chores and tasks, while children complete them to earn points that can be redeemed for customizable real-world rewards.",
    desc: "The TODO & Reward Tracker is an interactive, gamified web application built to make everyday chores, homework, and positive habits fun and engaging for kids. By blending task management with a point-based incentive system, the platform helps parents encourage accountability, consistency, and positive behavior in a positive, reward-driven environment.",
    features: [
      "Parents can create, edit, assign daily/weekly tasks, and set custom point values based on effort",
      "Parents review and approve completed task submissions before points are officially credited",
      "Children get a dedicated dashboard to view active tasks, current point balances, and submit tasks in one click",
      "Virtual Reward Shop where parents configure custom rewards and children can redeem earned points",
      "Habit & Streak Tracking to encourage daily task completion and build long-term positive routines"
    ],
  },
  {
    id: "ask-astra",
    name: "AskAstra",
    category: "Students",
    tagColor: "#2878C0",
    price: "Free",
    image: "/assets/store/ask.png",
    shortDesc: "AskAstra is an intelligent, personalized interview preparation system designed to help students and job seekers practice and master interview skills using artificial intelligence.",
    desc: "AskAstra – Project Overview AskAstra is an intelligent, personalized interview preparation system designed to help students and job seekers practice and master interview skills using artificial intelligence. The platform simulates real-world interview scenarios, analyzes user responses, and provides detailed feedback to improve confidence, communication, and performance.The application uses Natural Language Processing (NLP), Machine Learning, and Generative AI models to generate questions, evaluate answers, and guide users across different domains such as technical interviews, HR interviews, coding interviews, and behavioral assessments.",
    features: [],
  },
  {
    id: "cms",
    name: "Complaint Management System",
    category: "Industrial",
    tagColor: "#2878C0",
    price: "Contact",
    image: "/assets/store/1.png",
    shortDesc: "A full-stack enterprise web application designed to digitize and streamline multi-campus grievance redressal.",
    desc: "The Complaint Management System (CMS) is a production-grade enterprise web application built to centralize and automate complaint resolution across academic campuses. Operating on a standard three-tier client-server architecture, CMS replaces slow, manual ticketing processes with dynamic automated routing, strict data encryption guardrails, and real-time dashboard telemetry.",
    features: [
      "Completely Customizable",
      "Stateless submission mechanics supporting custom track-IDs with optional name anonymity protocols",
      "Dynamic 5-layer automated fallback routing engine prioritizing multi-field parameters down to available staff arrays",
      "Role-based access controls with isolated dashboards for public tracking, staff ticket management, and admin controls",
      "Automated 30-second background telemetry polling to surface real-time dashboard updates without WebSocket overhead",
      "One-click data export stream compiling filtered system tables into raw, spreadsheet-ready CSV structures via json2csv",
      "Stateless security guardrails with signed 8-hour JWT authentication layers and 10-round bcrypt password hashing"
    ]
  },
];